var map = {
	"./Excel.svg": "5752",
	"./PowerPoint.svg": "6486",
	"./add-colored.svg": "fe47",
	"./add.svg": "1ebb",
	"./ai-generate-button-disabled.svg": "4562",
	"./ai-generate-button.svg": "761b",
	"./ai-sparkle.svg": "c98f",
	"./answered.svg": "434d",
	"./arrow-left.svg": "931e",
	"./arrow-no-tail-black.svg": "115f",
	"./arrow-no-tail-white.svg": "98a8",
	"./arrow-no-tail.svg": "7de2",
	"./arrow-tail.svg": "52f5",
	"./arrow.svg": "33a42",
	"./arrows-clock-wise.svg": "aeff",
	"./audience-feedback.svg": "a92a",
	"./audience.svg": "8eb6",
	"./award.svg": "2033",
	"./b-key.svg": "cbb6",
	"./backstage.svg": "4c9d",
	"./banned.svg": "5969",
	"./bar-chart-square.svg": "2d21",
	"./bill.svg": "be0d",
	"./bin-empty.svg": "cf41",
	"./blink.svg": "627e",
	"./bottom_direction.svg": "6dc8",
	"./brainstorm-white.svg": "9cc6",
	"./brainstorm.svg": "6a08",
	"./bring-forward.svg": "383c",
	"./bring-to-front.svg": "ff20",
	"./c-key.svg": "6b27",
	"./categorise-white.svg": "3e14",
	"./categorise.svg": "5064",
	"./change-text-color.svg": "0e40",
	"./chat-canvas-noti.svg": "ba21",
	"./chat-canvas.svg": "d2ca",
	"./chat.svg": "4022",
	"./chat2.svg": "92b3",
	"./check.svg": "fbf4",
	"./chevron-right-2.svg": "92c3",
	"./chevron-right.svg": "ffbd",
	"./circle-audience-color.svg": "86e1",
	"./circle-audience.svg": "0029",
	"./circle-check-mark-color.svg": "fe49",
	"./circle-check-mark.svg": "506b",
	"./circle-check-with-border.svg": "9d88",
	"./circle-check.svg": "913b",
	"./circle-heart-color.svg": "2041",
	"./circle-heart.svg": "48a7",
	"./circle-star-color.svg": "ea38",
	"./circle-star.svg": "2107",
	"./circle-submission-color.svg": "44c7",
	"./circle-submission.svg": "4f70",
	"./clear.svg": "91f9",
	"./clip.svg": "3db0",
	"./close-round.svg": "597a",
	"./close-small.svg": "e515",
	"./close.svg": "5765",
	"./cloud-colored.svg": "c29a",
	"./cloud-import.svg": "6eb4",
	"./cloud.svg": "805a",
	"./coin.svg": "8dcd",
	"./comment.svg": "66f9",
	"./community-v2.svg": "8eb2",
	"./community.svg": "6fad",
	"./connection-error.svg": "6675",
	"./connection-good.svg": "e1d6",
	"./connection-unstable.svg": "7f35",
	"./content-w.svg": "df9b",
	"./content.svg": "f527",
	"./copy-b.svg": "9977",
	"./copy-regular.svg": "13ad",
	"./copy-to-another-slide.svg": "a14d",
	"./copy-to-workspace.svg": "c3a9",
	"./copy.svg": "8a3d",
	"./correct-order-w.svg": "fbb2",
	"./correct-order.svg": "9250",
	"./correct.svg": "4529",
	"./ctrl-key.svg": "e8ec",
	"./cut.svg": "10c6",
	"./d-key.svg": "6c00",
	"./default-thumbnail.svg": "4871",
	"./default_direction.svg": "5fdc",
	"./delete-key.svg": "d5aa",
	"./delete.svg": "1822",
	"./delete2.svg": "212b1",
	"./dislike.svg": "7281",
	"./document-dark.svg": "23e3",
	"./document-excel.svg": "c57c",
	"./document-w.svg": "d5d1",
	"./document.svg": "98f2",
	"./documents.svg": "0db0",
	"./donut-w.svg": "22d9",
	"./donut.svg": "d944",
	"./download-2.svg": "3b78",
	"./download.svg": "5bd5",
	"./draw.svg": "b547",
	"./duplicate.svg": "22cb",
	"./duplicated.svg": "2671",
	"./edit-2.svg": "6a45",
	"./edit.svg": "9461",
	"./empty-photo.svg": "9684",
	"./error.svg": "911c",
	"./export.svg": "a858",
	"./f-key.svg": "a471",
	"./fb.svg": "683c",
	"./feedback-filled.svg": "64c0",
	"./feedback-solid.svg": "2d60",
	"./feedback.svg": "c2c6",
	"./file.svg": "dd2a",
	"./flag-checkered.svg": "c271",
	"./flip-horizontal.svg": "4444",
	"./flip-vertical.svg": "487f",
	"./folder.svg": "b09e",
	"./gg.svg": "13f9",
	"./gif.svg": "2817",
	"./google-drive.svg": "0bfc",
	"./google-slides-w.svg": "8182",
	"./google-slides.svg": "6ee4",
	"./grid-4-dots.svg": "5aaa",
	"./grid-9-dots.svg": "300c",
	"./grid-w.svg": "bd51",
	"./grouping-open-ended.svg": "ea54",
	"./guess-number.svg": "c5846",
	"./hamburger-light.svg": "36dc",
	"./hamburger-menu.svg": "c06f",
	"./hand-pointer.svg": "26eb",
	"./heading-w.svg": "ed43",
	"./heading.svg": "092f",
	"./heart.svg": "479e",
	"./hide.svg": "7b2e",
	"./hide_correct_answer.svg": "aeb4",
	"./hide_result.svg": "9ebe",
	"./hint.svg": "fe14",
	"./home.svg": "00f2",
	"./hourglass.svg": "1528",
	"./icon-multiple-language.svg": "faf1",
	"./idea.svg": "abaf",
	"./image-choice-w.svg": "f7e4",
	"./image-choice.svg": "bb69",
	"./image-w.svg": "bbde",
	"./image.svg": "7df8",
	"./import-no-background.svg": "137a",
	"./import.svg": "4bab",
	"./inb.svg": "9484",
	"./incorrect.svg": "879b",
	"./info-circle.svg": "4cc1",
	"./information.svg": "2231",
	"./inspiration.svg": "3d8f",
	"./integrations.svg": "71af",
	"./invite-v2.svg": "e8aa",
	"./invite.svg": "bcb1",
	"./k-button.svg": "2aa7",
	"./kebab-menu-share.svg": "68dc",
	"./kebab-menu.svg": "6b850",
	"./key.svg": "0d1c",
	"./keyboard-enter.svg": "1688",
	"./laptop-and-pc.svg": "3edf",
	"./laugh.svg": "2cb6",
	"./laught.svg": "86b9",
	"./left_direction.svg": "70ab",
	"./lightbulb.svg": "a88a",
	"./like.svg": "78e8",
	"./line-arrow.svg": "b170",
	"./line.svg": "821c",
	"./list-type.svg": "809a",
	"./list-w.svg": "31bc",
	"./list.svg": "b681",
	"./lock-sub.svg": "7989",
	"./lock.svg": "1413",
	"./lockv2.svg": "9e4b",
	"./logo-icon-only.svg": "8522",
	"./logo.svg": "a6bb",
	"./logout.svg": "eacf",
	"./magic-slide.svg": "2864",
	"./magic-wand-colored.svg": "8e57",
	"./mail.svg": "4451",
	"./match-pairs-w.svg": "8697",
	"./match-pairs.svg": "a5cc",
	"./meta-key.svg": "a3af",
	"./microsoft.svg": "9122",
	"./minus.svg": "7aa1",
	"./miro-w.svg": "ee13",
	"./miro.svg": "4d21",
	"./more.svg": "b098",
	"./move.svg": "c5ee",
	"./ms-teams.svg": "6a39",
	"./mti-check.svg": "fba9",
	"./mti-comment.svg": "4c4b",
	"./mti-content.svg": "6b2f",
	"./mti-type-answer-w.svg": "1b9c",
	"./mti-type-answer.svg": "356e",
	"./multiple-choice-w.svg": "db8c",
	"./multiple-choice.svg": "1a89",
	"./music-note.svg": "eafd",
	"./music.svg": "06d6",
	"./name.svg": "a2df",
	"./newfolder.svg": "d061",
	"./no-presentation.svg": "1f08",
	"./no-result.svg": "f851",
	"./note-side-left-fill.svg": "fe9c",
	"./note-side-left.svg": "0ed9",
	"./note.svg": "62bd",
	"./one-by-one-w.svg": "74b1",
	"./one-by-one.svg": "962c",
	"./open-ended-w.svg": "4160",
	"./open-ended.svg": "3dd6",
	"./open-new-window.svg": "be7d",
	"./paint.svg": "34cc",
	"./palette-2.svg": "0e924",
	"./palette.svg": "228e",
	"./paste.svg": "f102",
	"./pause.svg": "e3f7",
	"./payment.svg": "c878",
	"./pen.svg": "88cf",
	"./pending.svg": "36dd",
	"./people-group.svg": "db291",
	"./people.svg": "854e",
	"./phone-share.svg": "90ab",
	"./phone.svg": "d7f5",
	"./pick-answer-w.svg": "3204",
	"./pick-answer.svg": "500a",
	"./pick-image-w.svg": "1576",
	"./pick-image.svg": "20f2",
	"./piechart-w.svg": "831b",
	"./piechart.svg": "fd3b",
	"./pin-on-image.svg": "0653",
	"./play.svg": "9d85",
	"./poll-colored.svg": "e556",
	"./poll.svg": "9a6b",
	"./polygon.svg": "d36c",
	"./ppt-add-in.svg": "cb5ac",
	"./present.svg": "f1c9",
	"./presentations.svg": "36ab",
	"./presenter-light.svg": "72c9",
	"./presenter-solid.svg": "1492",
	"./presenter.svg": "41e3",
	"./profile-light-dark.svg": "1afa",
	"./profile-light.svg": "db19",
	"./profile-solid.svg": "0ef4",
	"./profile.svg": "c022",
	"./profile_info.svg": "45c8",
	"./profile_logout.svg": "6327",
	"./profile_terms.svg": "31fd",
	"./profile_tutorial.svg": "ab02",
	"./q&a-w.svg": "e3cd",
	"./qa.svg": "0f4b",
	"./qna-colored.svg": "993a",
	"./qr-code-w.svg": "07c9",
	"./qr-code.svg": "25e5",
	"./qr-code2.svg": "d845",
	"./question-top-bar.svg": "72f7",
	"./question.svg": "8d06",
	"./quiz-answer.svg": "b3af",
	"./received-checked.svg": "8a5d",
	"./reconnecting.svg": "3397",
	"./redo.svg": "566a",
	"./reload.svg": "28b5",
	"./remove.svg": "bafd",
	"./replay.svg": "ad34",
	"./reposition.svg": "4e01",
	"./request.svg": "ad30",
	"./reset.svg": "6186",
	"./restore.svg": "50ff",
	"./review-slides.svg": "a19d",
	"./ribbon-star.svg": "8126",
	"./right_direction.svg": "c0c9",
	"./rotate-left.svg": "0aa1",
	"./rotate-right.svg": "529a",
	"./sad.svg": "c313",
	"./save.svg": "69f3",
	"./scales-w.svg": "8866",
	"./scales.svg": "9dbd",
	"./search.svg": "0c8d",
	"./selected-hint.svg": "81b0",
	"./send-backward.svg": "ddaf",
	"./send-button.svg": "dd3e",
	"./send-rotate.svg": "6beb",
	"./send-to-back.svg": "ed6a",
	"./send.svg": "6341",
	"./setting-top-bar.svg": "da8b",
	"./setting.svg": "d307",
	"./shape-circle.svg": "65e0",
	"./shape-square.svg": "366f",
	"./shape-star.svg": "6074",
	"./shape-triangle.svg": "4999",
	"./shape.svg": "40c4",
	"./share-collab.svg": "157a",
	"./share-v2.svg": "f19e",
	"./share.svg": "3eb8",
	"./shared-folder.svg": "184d",
	"./shift-key.svg": "62de",
	"./show_correct_answer.svg": "f7cc",
	"./show_result.svg": "1b84",
	"./shuffle.svg": "e00b",
	"./slides.svg": "5d75",
	"./sparkles-white.svg": "08a0",
	"./sparkles.svg": "1898",
	"./spinner-wheel-bg-dark-v2.svg": "c41e",
	"./spinner-wheel-bg-dark.svg": "2c40",
	"./spinner-wheel-bg-white-v2.svg": "8592",
	"./spinner-wheel-bg-white.svg": "31ff",
	"./spinner-wheel-colored.svg": "8b1a",
	"./spinner-wheel-w.svg": "d68f",
	"./spinner-wheel.svg": "23df",
	"./spinner.svg": "0848",
	"./star-fill.svg": "6e90",
	"./star-half.svg": "f930",
	"./stop-dark.svg": "36a7",
	"./stopwatch.svg": "563f",
	"./streak.svg": "d1ef",
	"./template.svg": "b823",
	"./tenor.svg": "a821",
	"./terms.svg": "f37c",
	"./text.svg": "7e5d",
	"./timer.svg": "2cd0",
	"./trophy-colored.svg": "f0e3",
	"./trophy.svg": "db69",
	"./tutorial.svg": "7c34",
	"./tutorial_video.svg": "4995",
	"./type-answer-w.svg": "d6bc",
	"./type-answer.svg": "a5a7",
	"./type-image.svg": "c976",
	"./undo.svg": "65e02",
	"./unhide.svg": "2347",
	"./unlock.svg": "5d9d",
	"./unlockv2.svg": "fb07",
	"./unsplash.svg": "577b",
	"./up_direction.svg": "039f",
	"./upload-image.svg": "47ea",
	"./user-solid.svg": "f3ce",
	"./users.svg": "16fb",
	"./v-key.svg": "4549",
	"./videos.svg": "dd61",
	"./warning-circle.svg": "d8c1",
	"./warning.svg": "7854",
	"./whats-new.svg": "f220",
	"./whats-new_red.svg": "a51d",
	"./wheel-background.svg": "6338",
	"./white-logo.svg": "014c",
	"./wider-than-1180px.svg": "183a",
	"./word-cloud-grouping.svg": "29e7",
	"./word-cloud-w.svg": "5915",
	"./word-cloud.svg": "a813",
	"./wow.svg": "a910",
	"./x-key.svg": "dd25",
	"./youtube-w.svg": "ba3b",
	"./youtube.svg": "30d2",
	"./z-key.svg": "a188",
	"./zoom-in.svg": "a370",
	"./zoom-out.svg": "3cc7",
	"./zoom.svg": "79b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b9a";